module.exports = __webpack_public_path__ + "7a6976b82c69268d04557a31b998c933.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/intro-panel-texture-1080.webp.png
// module id = 409
// module chunks = 0